import styled from "styled-components";

export const GeneralStyle = styled.div`
  background-color: ${({ colorPickerPreview }) => colorPickerPreview};
  background-image: url(${({ backgroundPreview }) => backgroundPreview});
  padding: 1rem;
  font-family: ${({ theme }) => theme.font.quinary};

  h1 {
    text-align: center;
    color: ${({ theme }) => theme.neutral.gray[1300]};
    padding: 20px 15px;
    color: ${({ theme }) => theme.text.primary};
  }

  footer {
    color: ${({ theme }) => theme.primary.purple};
    align-self: center;
    text-align: center;
    font-weight: bold;
  }

  .title-field {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .public-DraftEditorPlaceholder-root {
    color: ${({ theme }) => theme.neutral.gray[900]};
    font-size: 26px;
    width: 100%;
    text-align: center;
    font-weight: 700;
  }

  .wrapper-class {
    background-color: transparent !important;
    border: none !important;
  }

  .wrapper-class:focus-within {
    background-color: ${({ theme }) => theme.neutral.white} !important;
    border: 1px solid ${({ theme }) => theme.neutral.gray[200]} !important;
  }

  .editor-class {
    height: 100% !important;
    overflow: initial;
  }
`;

export const ButtonSubmit = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.button.primaryBorder};
  background-color: transparent;
  border-radius: 4px;
  color: ${({ theme }) => theme.button.primaryBorder};
  width: 12em;
  height: 40px;
  font-size: 13px;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primary.purpleOpacity};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const BlockWrapper = styled.div`
  display: grid;
  ${({ isDependent }) => isDependent && `margin-left: 5em;`}
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr 1px;
  grid-template-columns: minmax(80%, 710px);
  justify-content: center;
  svg {
    cursor: pointer;
    width: 27%;
    justify-self: center;
    height: 27%;
  }
`;
export const StyledButton = styled.button`
  align-self: center;
  justify-self: center;
  margin-bottom: 0.5rem;
  margin-top: 2em;
  margin-right: 0.4em;
  width: ${({ style }) => (style && style.fontSize === 14 ? "8rem" : "auto")};
  height: ${({ style }) => (style && style.fontSize === 14 ? "2rem" : "auto")};
  outline: 0;
  padding: 6px 12px;
  color: ${({ theme }) => theme.neutral.white};
  border-radius: 3px;
  border: none;
  margin-top: 2em;
  background: ${({ theme }) => theme.primary.purple};
  transition: transform 0.1s ease;
  min-width: 100px;
  &:hover {
    box-shadow: 0px 4px 20px 0px
      ${({ style, theme: localTheme }) =>
    style ? style.backgroundColor : localTheme.primary.purpleOpacity};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const StyledButtonCancel = styled.button`
  align-self: center;
  justify-self: center;
  margin-right: 0.4rem;
  width: 8rem;
  height: 2rem;
  outline: 0;
  padding: 6px 12px;
  color: ${({ theme }) => theme.button.primaryBorder};
  margin-top: 20px;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.button.primaryBorder};
  background: ${({ theme }) => theme.neutral.white};
  transition: transform 0.1s ease;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primary.purpleOpacity};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const StyledButtonGenericQuestion = styled.button`
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  margin-right: 0.6rem;
  width: 5rem;
  height: 2rem;
  outline: 0;
  color: ${({ theme }) => theme.primary.purple};
  margin-top: 20px;
  padding: 0;
  border: none;
  background: none;
  border-right: ${({ lastElement }) =>
    !lastElement ? "1px solid #cccc" : "none"};
  transition: transform 0.1s ease;
  vertical-align: middle;
  &:hover {
    cursor: pointer;
  }

  svg {
    width: 18px !important;
    height: 21px !important;
    margin-right: 5px;
  }
`;

export const ContainerLogo = styled.div`
  display: flex;
  justify-content: ${({ positionLogoPreview }) => positionLogoPreview};
  padding: 25px;
`;
// width: 200px;
export const SurveyQuestionConfigurationContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TitlePreview = styled.div`
  display: flex;
  justify-self: flex-start;
  justify-content: center;
  align-items: center;
  span {
    color: ${({ theme }) => theme.neutral.gray[300]};
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 19px;
    font-family: ${({ theme }) => theme.font.tertiary};
  }
`;

export const PreviewElements = styled.div`
  display: grid;
  justify-content: center;
  height: calc(80vh - 46px);
  overflow: auto;
  box-sizing: border-box;
  grid-template-columns: 100%;
  scrollbar-color: ${({ theme }) => theme.shadows.veryStrong} transparent;
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar:vertical {
    width: 10px;
  }
  &::-webkit-scrollbar:horizontal {
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: gray;
    border-radius: 20px;
    border: 2px solid ${({ theme }) => theme.neutral.gray[300]};
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
  }
`;

export const FooterElement = styled.div`
  padding: 15px;
  span {
    display: flex;
    justify-content: center;
    font-family: "Noto Sans", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: ${({ theme }) => theme.primary.purple};
  }
`;
export const HeaderDependency = styled.div`
  max-width: 600px;
  padding: 0.4em;
  background: ${({ theme }) => theme.primary.blue};
  color: white;
  height: auto;
  border-radius: 5px;
  margin-left: 6em;
  font-size: 16px;
  text-align: center;
  font-weight: 600;
`;
